import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NectaOneApiKeyDetailsDto, NectaOneApiKeyDto, CreateApiKeyRequest } from '../models/api-key.model';
import { ConfigService } from './config-service';

@Injectable({ providedIn: 'root' })
export class ApiKeyService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  private get baseUrl(): string {
    return `${this.configService.getUrlNectaOneApi()}`;
  }

  getApiKeys(): Observable<NectaOneApiKeyDetailsDto[]> {
    return this.http.get<NectaOneApiKeyDetailsDto[]>(`${this.baseUrl}/apikeys`);
  }

  createApiKey(request?: CreateApiKeyRequest): Observable<NectaOneApiKeyDto> {
    return this.http.post<NectaOneApiKeyDto>(`${this.baseUrl}/apikey`, request ?? {});
  }

  revokeApiKey(keyHash: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/apikey/revoke`, {}, { params: { keyHash } });
  }

  rotateApiKey(keyHash: string): Observable<NectaOneApiKeyDto> {
    return this.http.post<NectaOneApiKeyDto>(`${this.baseUrl}/apikey/rotate`, {}, { params: { keyHash } });
  }
}